"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAppBarServiceSection = exports.StyledAppBarBrandSection = exports.StyledAppBar = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../helpers");
const StackView_1 = require("../StackView");
exports.StyledAppBar = styled_components_1.default.div `
    flex-shrink: 0; /* if parent is flexbox-container */
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    height: ${helpers_1.SIZE_XXL};
    background-color: ${({ theme }) => theme.colorBackgroundHeader};
`;
exports.StyledAppBarBrandSection = (0, styled_components_1.default)(StackView_1.StackView) `
    overflow: hidden;
`;
exports.StyledAppBarServiceSection = styled_components_1.default.div `
    flex-shrink: 0;
    flex-grow: 1;
    display: flex;
    align-items: stretch;
    height: 100%;
`;
//# sourceMappingURL=AppBar.styles.js.map